import { Button, Modal } from 'antd';
import { useState } from 'react';

interface DocumentExpenseActionButtonProps {
  buttonText: string;
  buttonType: 'primary' | 'primary-danger';
  modalTitle: string;
  modalText: string;
  /**
   * Blocks the action without hiding it — an operator looking at a flagged document needs to see that
   * the action exists and, from the tooltip around it, why it is not theirs to press yet.
   */
  isDisabled?: boolean;
  onConfirm: () => void;
}

export const DocumentExpenseActionButtonWithConfirmation = (props: DocumentExpenseActionButtonProps) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => {
    if (props.isDisabled) {
      return;
    }

    setIsModalVisible(true);
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
  };

  const handleConfirm = () => {
    props.onConfirm();
    setIsModalVisible(false);
  };

  return (
    <>
      <Button
        type="primary"
        danger={props.buttonType === 'primary-danger'}
        size="large"
        disabled={props.isDisabled}
        onClick={showModal}
      >
        {props.buttonText}
      </Button>

      <Modal
        title={props.modalTitle}
        open={isModalVisible}
        onOk={handleConfirm}
        onCancel={handleModalCancel}
        okText="Confirm"
        cancelText="Cancel"
      >
        <p>{props.modalText}</p>
      </Modal>
    </>
  );
}; 